// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2oxdk","buttons":"RemoveExpirationActionButtons_buttons__2vtH8"};